import styles from "./Card.module.css";

const Card = ({
  image = "http://placehold.co/300x200",
  title,
  tech,
  description = "Criativdade em produção, novos projetos em breve!",
  githubCode,
  webView,
}) => {
  return (
    <div className={`${styles.card}`}>
      <a href={webView} target="_blank" rel="noreferrer">
        <img src={image} alt="project" />
      </a>
      <div className={styles.info}>
        <h3>{title}</h3>
        <p className={`section__subtitle ${styles.tech}`}>Tecnologias: {tech}</p>
        <p>{description}</p>
        <div>
          <a href={githubCode} target="_blank" rel="noreferrer">
            code <i className="fa-brands fa-github"></i>
          </a>
          <a href={webView} target="_blank" rel="noreferrer">
            web view <i className="uil uil-external-link-alt"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Card;
